import { render, staticRenderFns } from "./ShowTextAreaValue.vue?vue&type=template&id=1dbbaa04&"
import script from "./ShowTextAreaValue.vue?vue&type=script&lang=js&"
export * from "./ShowTextAreaValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports